"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApproveUseAuthorityInstruction = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const ApproveUseAuthorityArgs_1 = require("../types/ApproveUseAuthorityArgs");
const ApproveUseAuthorityStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    ['approveUseAuthorityArgs', ApproveUseAuthorityArgs_1.approveUseAuthorityArgsBeet],
], 'ApproveUseAuthorityInstructionArgs');
const approveUseAuthorityInstructionDiscriminator = 20;
function createApproveUseAuthorityInstruction(accounts, args) {
    const { useAuthorityRecord, owner, payer, user, ownerTokenAccount, metadata, mint, burner } = accounts;
    const [data] = ApproveUseAuthorityStruct.serialize({
        instructionDiscriminator: approveUseAuthorityInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: useAuthorityRecord,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: owner,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: payer,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: user,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: ownerTokenAccount,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: metadata,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: mint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: burner,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s'),
        keys,
        data,
    });
    return ix;
}
exports.createApproveUseAuthorityInstruction = createApproveUseAuthorityInstruction;
//# sourceMappingURL=ApproveUseAuthority.js.map